import React from "react";
import { IconT } from "types/utils";

const ListArrowIcon = ({ height = "14", width = "14", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none" aria-hidden>
      <path
        d="M4 5h7M4 10h5M4 15h7M14 6l3 4-3 4"
        stroke={fill}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default ListArrowIcon;
